import { Chip } from "@material-ui/core";
import { ChipRow, chipStyle } from "../../../_lib/epocus-chip";

export const FEEDBACK_TAGS = [
  "Great Job",
  "Too Deep",
  "Too Shallow",
  "Too Dark",
  "Too Bright",
  "Wrong Orientation",
  "Insufficient Views",
  "Pathology Missed",
  "Overcalled",
] as const;

export const FeedbackTagPicker: FC<{
  selected: readonly string[];
  onToggle: (tag: string) => void;
}> = ({ selected, onToggle }) => (
  <ChipRow>
    {FEEDBACK_TAGS.map((tag) => {
      const isSelected = selected.includes(tag);

      return (
        <Chip
          key={tag}
          label={tag}
          variant="outlined"
          onClick={() => onToggle(tag)}
          aria-pressed={isSelected}
          style={chipStyle(isSelected)}
        />
      );
    })}
  </ChipRow>
);
